import { orchestrator } from 'satcheljs';
import { onTimeStreamAssetCreated } from 'owa-timestream-store';
import { selectAsset } from '../actions';

orchestrator(onTimeStreamAssetCreated, ({ projectId, assetId, source }) => {
    // select the asset if the asset did not come from activity pane
    if (source !== 'ActivityPane') {
        selectAsset(assetId);
    }
});
